import Modal from 'developer_components/newModal';
import {createElement, error, hasWebpSupport, initObserver} from 'methods/utils';
import Swiper from 'swiper';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Модалка на странице объекта
 */
function RecallPhotogallery() {
    this._$container = document.querySelector('.js-recallList');
    if (!this._$container) {
        return;
    }

    this.update();
}

RecallPhotogallery.prototype.update = function() {
    initObserver();

    // список отзывов
    this._$container.querySelectorAll('.js-photogallery:not(.is-initialized)').forEach($photogallery => {
        $photogallery.classList.add('is-initialized');

        let $imageData = $photogallery.querySelector('.js-imageData');
        if (!$imageData) {
            return;
        }

        let images;
        try {
            images = JSON.parse($imageData.innerHTML);
        } catch(e) {
            error(e);
            return;
        }

        if (!images || images.length === 0) {
            return;
        }

        $photogallery.querySelectorAll('.js-item').forEach(($item, index) => {
            $item.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                // передаем выбранную фотку и сами фотки
                this._openModal(index, images)
            });
        });
    });
}

/**
 * Открываем модалку
 */
RecallPhotogallery.prototype._openModal = function(index, images) {
    this._images = images.map((item, pos) => {
        return `<div class="item swiper-slide loaded">
                    <img src="${item.original}" loading="lazy" />
                </div>`;
    });

    let footer  = ``;
    let $footer;

    // футер из фотогалереи объекта
    if (!$footer) {
        $footer = document.querySelector('#hotel-photogallery-modal .footer');
    }

    if ($footer) {
        footer = $footer.outerHTML;
    }

    // удаляем пред модалки
    document.querySelectorAll('#apartment-photogallery-modal').forEach($item => $item.remove());

    this._$modal = createElement(`
        <div id="apartment-photogallery-modal" class="Modal-native">
            <div class="wrapper Modal-native__wrapper">
                <div class="header">
                    <div class="left">
                        <button class="back js-modalClose">Назад</button>
                    </div>
                    <div class="right Page-menu-right js-headerRightBlock"></div>
                </div>

                <div class="content js-mainGallery">
                    <div class="swiper-wrapper">
                        ${this._images.join('')}
                    </div>
                </div>

                <div class="counter js-counter">1/${this._images.length}</div>

                ${footer}
            </div>
        </div>
    `);

    this._modal = new Modal(this._$modal);

    // добавляем в модалку кнопку избранного
    const $objectFavorite = document.querySelector('.js-objectFavorite')
    if ($objectFavorite) {
        this._$modal.querySelector('.js-headerRightBlock').append($objectFavorite.cloneNode(true));
    }

    // инициализация фоток
    this._initPhotogallery(index);

    this._modal.open();
}

/**
 * $el делает opacity с 1 до 0
 * В конце вызывает finishCallback
 */
RecallPhotogallery.prototype._opacityOut = function($el, finishCallback) {
    let myopacity = 1;
    finishCallback = typeof finishCallback === 'function' ? finishCallback : (() => {});

    function MyFadeFunction() {
        if (myopacity > 0) {
            myopacity -= 0.05;

            setTimeout(() => {
                MyFadeFunction()
            }, 10);
        } else {
            $el.remove();

            finishCallback();
        }

        $el.style.opacity = myopacity;
    }

    MyFadeFunction();
}

/**
 * Выбор фотки
 */
RecallPhotogallery.prototype._loadPhotogallerySlide = function(index = 0) {
    index = +index;
    if (isNaN(index)) {
        return;
    }

    this._prevIndex = index;
    let $item = this._$items[index];

    // фоток в контейнере
    let $images = [...this._$mainGallery.querySelectorAll('div')];

    // новые фотки добавляем
    let $div = document.createElement('div');
        $div.insertAdjacentHTML('afterbegin', `<img src="${$item.dataset.original}" loading="lazy">`);

    this._$mainGallery.insertAdjacentElement('afterbegin', $div);

    // пред фотки удаляем
    $images.forEach($image => {
        if ($image.classList.contains('removing')) {
            return false;
        }

        $image.classList.add('removing');

        this._opacityOut($image);
    });

    // обновляем счетчик
    this._$counter.textContent = `${+index + 1} / ${this._allCount}`;
}

/**
 * Инициализация фоток
 */
RecallPhotogallery.prototype._initPhotogallery = function(index) {
    this._$mainGallery  = this._$modal.querySelector('.js-mainGallery');
    this._$navGallery   = this._$modal.querySelector('.js-navGallery');
    this._$counter      = this._$modal.querySelector('.js-counter');
    this._$items        = [...this._$mainGallery.querySelectorAll('.item')];
    this._allCount      = this._$items.length;

    Swiper.use([Navigation, Pagination]);

    this._swiper = new Swiper(this._$mainGallery, {
        slidesPerView: 'auto',
    });

    let counterUpdater = () => {
        this._$counter.textContent = `${this._swiper.activeIndex + 1}/${this._allCount}`;
    }

    this._swiper.slideTo(index, 100);
    counterUpdater();

    this._swiper.on('slideChange', counterUpdater);

    window.addEventListener('keydown', (e) => {
        switch(e.keyCode) {
            case 27: // esc
                this._$modal.dispatchEvent(new Event('close'));
                break;
        }
    });

    // открытие модалки
    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('hotel_recall_gallery_open');
        collectYandexReachGoal(metrikaCollector, 'hotel_recall_gallery_open');
    }
}

export default RecallPhotogallery;
